import { SUGGESTION_CLASS } from '../store/schema/Suggestion';
import { trace } from 'owa-trace';

export default function logWarningIfCursorIsInsideSuggestionNode() {
    // This is temporary logging. I suspect that somehow users occasionally get into a state where the insertion point
    // is inside of the suggestion span. This should never happen, so throwing a warning here now so that if it happens
    // again in SDF we'll get notified
    const anchorNode = document.getSelection()?.anchorNode;
    const selectionNode = anchorNode?.nodeType === 3 ? anchorNode.parentElement : null;
    if (selectionNode?.className === SUGGESTION_CLASS) {
        trace.warn('[SmartComposePlugin] attempting to add text inside of suggestion span');
    }
}
